import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import clsx from "clsx";
import "./hubspotContainer.scss";
import { isIOSApp } from "../../../util/isIOSApp";
import { useHubspotConversationsContext } from "../utils/HubspotConversationsContext";

const HUBSPOT_INLINE_EMBED_ELEMENT_ID = "hubspot-conversations-inline-embed-selector";

export function HubspotContainer() {
    const { toggleWidget, isOpen } = useHubspotConversationsContext();

    return (
        <div
            className={clsx(
                "hubspot-container",
                !isOpen && "hubspot-container--hidden",
                isIOSApp() && "hubspot-container--native-ios"
            )}
            id={HUBSPOT_INLINE_EMBED_ELEMENT_ID}>
            <FontAwesomeIcon className="hubspot-container__close-icon" icon={faClose} onClick={toggleWidget} />
        </div>
    );
}
